import Icon, { IconType } from 'components/Icon';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { selectActiveDesignSystem } from 'redux/db/reducers';
import { RootReducer } from 'redux/reducers';
import * as routes from 'routes';
import { shallowEqual } from 'react-redux';
import * as S from './styles';

interface DsUpdateCardProps {
	updateType: 'tokens' | 'primitives' | 'components' | 'stories';
	isMobile?: boolean;
	showPendingNote?: boolean;
}

const UPDATE_TYPE_CONFIG = {
	tokens: {
		icon: IconType.LAYOUT,
		title: 'Tokens Updated',
		viewLabel: 'View Tokens',
		sectionParam: 'tokens',
	},
	primitives: {
		icon: IconType.STYLE,
		title: 'Primitives Updated',
		viewLabel: 'View Primitives',
		sectionParam: 'styles',
	},
	components: {
		icon: IconType.COMPONENT,
		title: 'Components Updated',
		viewLabel: 'View Components',
		sectionParam: 'components',
	},
	stories: {
		icon: IconType.FILE,
		title: 'Stories Updated',
		viewLabel: 'View Stories',
		sectionParam: 'stories',
	},
} as const;

const DsUpdateCard = ({ updateType, isMobile, showPendingNote }: DsUpdateCardProps) => {
	const navigate = useNavigate();
	const designSystem = useSelector(
		(r: RootReducer) => selectActiveDesignSystem(r.db, r.mode.activeDesignSystemId),
		shallowEqual
	);

	const config = UPDATE_TYPE_CONFIG[updateType];

	const handleViewClick = () => {
		if (!designSystem) return;
		const url = routes.designSystem(designSystem.id, designSystem.title);
		navigate(`${url}?section=${config.sectionParam}`);
	};

	return (
		<S.UpdateCard isMobile={isMobile} onClick={handleViewClick}>
			<S.UpdateTitleRow>
				<S.UpdateIcon>
					<Icon type={config.icon} width={16} height={16} />
				</S.UpdateIcon>
				<S.UpdateTitle>{config.title}</S.UpdateTitle>
			</S.UpdateTitleRow>
			{showPendingNote && (
				<S.UpdateNote isMobile={isMobile}>Changes apply when chat completes</S.UpdateNote>
			)}
		</S.UpdateCard>
	);
};

export default DsUpdateCard;
